import { PauseCover } from "aic";
import { useHierarchyContext } from "contexts/AppSettingsContext";
import { getHierarchyBaseUrl } from "contexts/hierarchy/getHierarchyBaseUrl";
import { eHierarchyLevel } from "functions/api/enums";
import { NavDropdown } from "react-bootstrap";
import { Link, useNavigation } from "react-router-dom";
import { REACT_APP_STAGE } from "../../config";

interface NewItemDropMenuProps {
  fileEntry?: React.ReactElement;
}

/**
 * Dropdown menu for creating new items (table, listing, figure).
 *
 * @param props - Destructured props for the new-item menu.
 * @param props.fileEntry - Optional element to display additional file actions.
 * @returns A JSX element rendering the new-item dropdown.
 */
export const NewItemDropMenu = ({ fileEntry }: NewItemDropMenuProps): React.ReactElement => {
  const hierarchyContext = useHierarchyContext();
  const navigation = useNavigation();
  const hierarchyBaseUrl =
    hierarchyContext &&
    hierarchyContext.hierarchy &&
    hierarchyContext.hierarchy.level !== eHierarchyLevel.Study
      ? getHierarchyBaseUrl(hierarchyContext.hierarchy)
      : // istanbul ignore next
        "/Corporate";

  return (
    <NavDropdown
      id="topbar-file"
      title="File"
      style={{ paddingLeft: "12px", position: "relative" }}
    >
      {navigation.state === "loading" && <PauseCover text="Loading New Template..." />}
      {hierarchyContext?.hierarchy?.arsEnabled &&
        ["local", "development", "test", "__REACT_APP_STAGE__"].includes(REACT_APP_STAGE) && (
          <>
            <NavDropdown.Item
              id="topbar-new-ars-table-link"
              as={Link}
              to={`${hierarchyBaseUrl}/NewTlf/newArsTable`}
            >
              New ARS Table
            </NavDropdown.Item>
            <NavDropdown.Item
              id="topbar-new-ars-listing-link"
              as={Link}
              to={`${hierarchyBaseUrl}/NewTlf/newArsListing`}
            >
              New ARS Listing
            </NavDropdown.Item>
          </>
        )}
      <NavDropdown.Item
        id="topbar-new-table-link"
        as={Link}
        to={`${hierarchyBaseUrl}/NewTlf/newTable`}
      >
        New Table
      </NavDropdown.Item>
      <NavDropdown.Item
        id="topbar-new-listing-link"
        as={Link}
        to="/Corporate/AZLBL01/2"
      >
        New Listing
      </NavDropdown.Item>
      <NavDropdown.Item
        id="topbar-new-figure-link"
        as={Link}
        to={`${hierarchyBaseUrl}/NewTlf/newFigure`}
      >
        New Interactive Figure
      </NavDropdown.Item>
      <NavDropdown.Item
        id="topbar-new-v1figure-link"
        as={Link}
        to={`${hierarchyBaseUrl}/NewTlf/newV1Figure`}
      >
        New Static Figure
      </NavDropdown.Item>
      {fileEntry !== undefined && <>{fileEntry}</>}
    </NavDropdown>
  );
};

NewItemDropMenu.displayName = "NewItemDropMenu";
